/******************************************************************************************
 *	Sort Products Service
 *******************************************************************************************
 *
 * Sorts products according to preference (e.g. Creative Cloud on top), then alphabetically.
 *
 */
(function() {
  

  angular
    .module('rcServices.defaultProductsSorter', [])
    .constant('PRODUCT_CODE_PREFERENTIAL_ORDER', ['CCLE', 'CTSK'])
    .factory(
      'defaultProductsSorter',
      /* @ngInject */
      function(PRODUCT_CODE_PREFERENTIAL_ORDER, Utility) {
        //`productCodePath` and `productNamePath` are strings which represent
        //the "path" to the product code and name on the object being sorted.
        //For example, `productCodePath` would be "productInfo.productCode"
        //for an object looking like `obj.productInfo.productCode`.
        function sorterWrapper(productCodePath, productNamePath) {
          function sorter(a, b) {
            //Extract product code and name from objects that are being compared
            var productCodeA = Utility.getValueFromPropertySequence(a, productCodePath);
            var productNameA = Utility.getValueFromPropertySequence(a, productNamePath);
            var orderIndexA = PRODUCT_CODE_PREFERENTIAL_ORDER.indexOf(productCodeA);
            var productCodeB = Utility.getValueFromPropertySequence(b, productCodePath);
            var productNameB = Utility.getValueFromPropertySequence(b, productNamePath);
            var orderIndexB = PRODUCT_CODE_PREFERENTIAL_ORDER.indexOf(productCodeB);

            //Both products require preferential order, sort by their order index
            if (orderIndexA > -1 && orderIndexB > -1) {
              return orderIndexA - orderIndexB;
            } else if (orderIndexA > -1) {
              //Just the first requires preferential order, preserve order
              return -1;
            } else if (orderIndexB > -1) {
              //Just the second requires preferential order, reverse order
              return 1;
            }
            if (productCodeA === 'SUPPORT') {
              //sort Support last
              return 1;
            }
            if (productCodeB === 'SUPPORT') {
              //sort Support last
              return -1;
            }

            //Default to alphabetical order
            return productNameA > productNameB ? 1 : -1;
          }
          return sorter;
        }
        return sorterWrapper;
      }
    );
})();
